import { render } from "./ChatsViewPage.vue?vue&type=template&id=7144e80a&scoped=true"
import script from "./ChatsViewPage.vue?vue&type=script&lang=js"
export * from "./ChatsViewPage.vue?vue&type=script&lang=js"

import "./ChatsViewPage.vue?vue&type=style&index=0&id=7144e80a&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7144e80a"]])

export default __exports__